(function () {
  const KEY = 'evvo:recently-viewed';

  const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
  const write = (a) => { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch {} };

  const currentHandle = document.querySelector('.rvp')?.dataset.current;
  if (currentHandle) {
    const list = read().filter(h => h !== currentHandle);
    list.unshift(currentHandle);
    write(list.slice(0, 20));
  }

  document.querySelectorAll('.rvp').forEach(init);

  function money(cents) {
    return '₹ ' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
  }

  function clip(title, max) {
    if (!max || title.length <= max) return title;
    const cut = title.slice(0, max);
    const space = cut.lastIndexOf(' ');
    return (space > max * 0.6 ? cut.slice(0, space) : cut).replace(/[\s,.-]+$/, '') + '…';
  }

  function card(p, maxChars) {
    const v = p.variants[0];
    const onSale = v.compare_at_price && v.compare_at_price > v.price;
    const off = onSale ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0;
    const img = p.featured_image || (p.images && p.images[0]) || '';
    const full = esc(p.title);
    const shown = esc(clip(p.title, maxChars));
    return `
      <li class="rvp__card">
        <a href="/products/${p.handle}" title="${full}">
          <div class="rvp__media">${img ? `<img src="${img}&width=500" alt="${full}" loading="lazy" width="500" height="500">` : ''}</div>
          <p class="rvp__title">${shown}</p>
          <div class="rvp__price">
            <span class="rvp__price-now">${money(v.price)}</span>
            ${onSale ? `<span class="rvp__price-was">${money(v.compare_at_price)}</span><span class="rvp__price-off">(${off}% Off)</span>` : ''}
          </div>
        </a>
      </li>`;
  }

  async function init(section) {
    const limit = parseInt(section.dataset.limit, 10) || 12;
    const maxChars = parseInt(section.dataset.titleChars, 10) || 0;
    const current = section.dataset.current;
    const handles = read().filter(h => h !== current).slice(0, limit);
    if (!handles.length) return;

    const results = await Promise.all(handles.map(h =>
      fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : null).catch(() => null)
    ));

    const items = results.filter(Boolean);
    if (!items.length) return;

    const track = section.querySelector('.rvp__track');
    track.innerHTML = items.map(p => card(p, maxChars)).join('');
    section.hidden = false;

    const prev = section.querySelector('.rvp__arrow--prev');
    const next = section.querySelector('.rvp__arrow--next');
    const bar = section.querySelector('.rvp__progress-bar');
    const page = () => track.clientWidth * 0.9;

    prev.addEventListener('click', () => track.scrollBy({ left: -page(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: page(), behavior: 'smooth' }));

    function update() {
      const max = track.scrollWidth - track.clientWidth;
      const ratio = track.clientWidth / track.scrollWidth;
      bar.style.width = Math.min(ratio * 100, 100) + '%';
      bar.style.transform = `translateX(${max > 0 ? (track.scrollLeft / max) * ((1 / ratio) - 1) * 100 : 0}%)`;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4;
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
})();